module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersWidgetLinks":{"deselect":"- Vyberte -"}},"de":{"CatalogFiltersWidgetLinks":{"deselect":"- Wählen Sie -"}},"sk":{"CatalogFiltersWidgetLinks":{"deselect":"- Vyberte -"}}}')
  delete Component.options._Ctor
}
